import React, { Component } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import Layout from "../../Layout/layout";
import { apiHost } from "../../api/apiClient";
import { authConfig, getYouTubeId } from "./helpCentreUtils";
import helpCentreHero from "../../assets/visiontrak-help-centre-hero.png";
import "../../styles/helpCentre/helpCentre.scss";

class HelpCentre extends Component {
  state = { activeTab: "manuals", loading: true, error: "", videos: [], selectedId: null };

  componentDidMount() { this.load(); }

  load = async () => {
    try {
      const response = await axios.get(`${apiHost}/api/HelpCentre`, authConfig());
      const videos = response.data.videos || [];
      this.setState({ videos, selectedId: videos[0]?.id || null, loading: false });
    } catch (error) {
      this.setState({ error: error.response?.status === 403 ? "The Help Centre is currently available to administrators only." : "The Help Centre could not be loaded.", loading: false });
    }
  };

  render() {
    const { activeTab, loading, error, videos, selectedId } = this.state;
    const selected = videos.find(video => video.id === selectedId) || videos[0];
    const youtubeId = getYouTubeId(selected?.youTubeUrl);
    return (
      <Layout>
        <Helmet><title>Help Centre</title></Helmet>
        <main className="help-centre-page">
          <header className="help-centre-hero">
            <div className="help-centre-hero-copy"><span className="help-centre-eyebrow">VisionTrak Support</span><h1>Help Centre</h1><p>Find documentation, practical guides and step-by-step video tutorials.</p></div>
            <div className="help-centre-hero-art" aria-hidden="true"><img src={helpCentreHero} alt="" /></div>
          </header>
          <nav className="help-centre-tabs" aria-label="Help Centre sections">
            <button className={activeTab === "manuals" ? "active" : ""} onClick={() => this.setState({ activeTab: "manuals" })}><i className="fa fa-graduation-cap"></i> Training &amp; Guides</button>
            <button className={activeTab === "videos" ? "active" : ""} onClick={() => this.setState({ activeTab: "videos" })}><i className="fa fa-play-circle"></i> Videos</button>
          </nav>
          {loading && <section className="help-centre-state">Loading Help Centre…</section>}
          {error && <section className="help-centre-state error">{error}</section>}
          {!loading && !error && activeTab === "manuals" && (
            <div className="help-centre-manuals">
              <section className="help-centre-manual-card help-centre-training-card">
                <div className="help-centre-manual-icon"><i className="fa fa-graduation-cap"></i></div>
                <div><span className="help-centre-eyebrow">Training resources</span><h2>Training &amp; Getting Started</h2><p>To help you get the most out of VisionTrak, we’ve put together step-by-step training guides and documentation covering:</p>
                  <ul>
                    <li>Portal navigation &amp; key features</li>
                    <li>Asset setup and tracking basics</li>
                    <li>Reports, alerts, and best practices</li>
                  </ul>
                  <a href="https://tinyurl.com/visiontrak-training-docs" target="_blank" rel="noopener noreferrer">Access VisionTrak Training Documentation <i className="fa fa-external-link"></i></a>
                  <p className="help-centre-bookmark-note"><i className="fa fa-bookmark"></i><span>We recommend bookmarking the training documentation.</span><small>It’s regularly updated as new features are added.</small></p>
                </div>
              </section>
            </div>
          )}
          {!loading && !error && activeTab === "videos" && (
            videos.length ? <section className="help-video-library">
              <div className="help-video-list" role="list">
                {videos.map(video => { const id=getYouTubeId(video.youTubeUrl); return <button key={video.id} className={video.id === selected?.id ? "active" : ""} onClick={() => this.setState({ selectedId: video.id })}>
                  <span className="help-video-thumb">{id && <img src={`https://img.youtube.com/vi/${id}/mqdefault.jpg`} alt="" />}<i className="fa fa-play"></i></span>
                  <span><strong>{video.title}</strong><small>{video.description}</small></span>
                </button>; })}
              </div>
              <article className="help-video-player-card">
                <div className="help-video-frame">{youtubeId && <iframe src={`https://www.youtube-nocookie.com/embed/${youtubeId}`} title={selected.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen />}</div>
                <div className="help-video-copy"><h2>{selected.title}</h2><p>{selected.description}</p></div>
              </article>
            </section> : <section className="help-centre-state">No help videos have been added yet.</section>
          )}
        </main>
      </Layout>
    );
  }
}

export default HelpCentre;
